import { observer } from "mobx-react-lite"
import Layout from "../components/layout/Layout"

import About2 from "../components/sections/About2";
import About3 from "../components/sections/About3";
import About4 from "../components/sections/About4";
import About1 from "../components/sections/About1";

const About = observer(() => {
    return (
        <Layout headerStyle={1} footerStyle={2} breadcrumbTitle="About">
            <About1/>
            <About2/>
            <About3/>
            <About4/>
        </Layout>
    )
})
export default About;